$(document).ready(function(){
$('.main_slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      fade: true,
      prevArrow:'<svg class="slick_arrows prev-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>',
      nextArrow:'<svg class="slick_arrows next-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
      asNavFor: '.ct_thumbnail ul'
    });
    $('.ct_thumbnail ul').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      vertical:false,
      asNavFor: '.main_slide',
      dots: false,
      arrows:true,
      focusOnSelect: true,
      adaptiveHeight: true,
      centerMode: false,
      prevArrow:'<svg class="slick_arrows prev-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>',
      nextArrow:'<svg class="slick_arrows next-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            arrows:true,
            centerMode: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 750,
          settings: {
            vertical: false,
            verticalSwiping:false,
            slidesToShow: 3,
            arrows:true,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 580,
          settings: {
            vertical: false,
            verticalSwiping:false,
            arrows:true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 380,
          settings: {
            vertical: false,
            verticalSwiping:false,
            arrows:true,
            slidesToShow: 3
          }
        }
      ]
    });
  });
$(document).ready(function() {
  $(".demo").show();

  $(".cut").click(function(){
    $(".demo").hide(500);
  });
  $("#mc-embedded-subscribe").click(function(){
  	$(".demo").hide(500);
  });
  $('.mail_chip_popup').on('wheel', function() {
    return false;
  });
});